module.exports = __webpack_public_path__ + "img/patrn.86359883.png";